import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { equals } from 'ramda';

const DocumentHistoryListState = ({ variant, loadedCount, onRetry }) => {
  const baseClass = 'flex items-center justify-center py-4 text-sm';

  if (equals(variant, 'loading')) {
    return (
      <div className={`${baseClass} text-flexi-grey gap-2`}>
        <LoadingOutlined spin />
        <span>Chargement de nouvelles entrées...</span>
      </div>
    );
  }

  if (equals(variant, 'loaded')) {
    return (
      <div className={`${baseClass} text-flexi-grey`}>
        {loadedCount} entrée{loadedCount > 1 ? 's' : ''} affichée{loadedCount > 1 ? 's' : ''}
      </div>
    );
  }

  if (equals(variant, 'end')) {
    return (
      <div className={`${baseClass} italic text-flexi-grey`}>
        Vous avez atteint la fin de l&apos;historique.
      </div>
    );
  }

  if (equals(variant, 'error')) {
    return (
      <div className={`${baseClass} text-flexi-history-error`}>
        <span>
          Impossible de charger de nouvelles entrées.&nbsp;
          <button
            onClick={onRetry}
            className="italic underline bg-transparent border-none cursor-pointer text-flexi-history-error p-0"
          >
            Réessayer
          </button>
        </span>
      </div>
    );
  }

  return null;
};

export default DocumentHistoryListState;
